import type { HealthState } from '@crosscastr/shared';

const R = 52;
const C = 2 * Math.PI * R; // ≈ 326.7 — matches the mockup geometry

const STATE_COLOR: Record<HealthState, string> = {
  ok: 'var(--ok)',
  warm: 'var(--warm)',
  risk: 'var(--risk)',
  muted: 'var(--muted)',
};

/**
 * Number Health Score gauge — the flagship component (DESIGN.md §5). A full-circle SVG ring whose
 * coloured arc length equals the score; state is carried by colour + label + motion (breathing
 * when warming, pulsing at-risk), never colour alone. Reused across Dashboard and Sessions.
 */
export function HealthGauge({
  score,
  state,
  size = 132,
  centerLabel = 'מצב המספר',
}: {
  score: number;
  state: HealthState;
  size?: number;
  centerLabel?: string;
}): JSX.Element {
  const offset = C * (1 - Math.max(0, Math.min(100, score)) / 100);
  const color = STATE_COLOR[state];
  return (
    <svg className="gauge-svg" viewBox="0 0 120 120" style={{ width: size, height: size }} role="img" aria-label={`מצב המספר ${score}`}>
      <circle cx="60" cy="60" r={R} fill="none" stroke="color-mix(in srgb, var(--text-dim) 16%, transparent)" strokeWidth="9" />
      <circle
        className={`gauge-ring ${state}`}
        cx="60" cy="60" r={R} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round"
        strokeDasharray={C} strokeDashoffset={offset} transform="rotate(-90 60 60)"
      />
      <text x="60" y="58" textAnchor="middle" fill="var(--text)" style={{ fontSize: 32, fontFamily: 'var(--font-mono)', fontWeight: 700 }}>
        {score}
      </text>
      <text x="60" y="76" textAnchor="middle" fill="var(--text-dim)" style={{ fontSize: 11, fontFamily: 'var(--font-body)' }}>
        {centerLabel}
      </text>
    </svg>
  );
}
